var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQmatchMenuIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 0.947368L17.5 17.0526C17.5 17.2724 17.2997 17.5 17 17.5L11 17.5C10.7003 17.5 10.5 17.2724 10.5 17.0526L10.5 0.947368C10.5 0.727586 10.7003 0.5 11 0.5L17 0.5C17.2997 0.5 17.5 0.727586 17.5 0.947368ZM7.5 0.947368L7.5 17.0526C7.5 17.2724 7.29967 17.5 7 17.5L0.999999 17.5C0.700326 17.5 0.499999 17.2724 0.499999 17.0526L0.5 0.947368C0.5 0.727586 0.700327 0.499999 1 0.499999L7 0.5C7.29967 0.5 7.5 0.727586 7.5 0.947368Z",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQmatchMenuIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/qmatch-menu-icon.e49dcb09.svg";
export { ForwardRef as ReactComponent };